const BASE_URL = document.getElementById('base_url').value;

const filterPageFaq = () => {
	if ( document.getElementById('faq-vue') ) {
		var app = new Vue({
			el: '#faq-vue',
			data() {
				return {
					faqs : [],
					page: 1,
					perPage: 6,
					pages: [],	
                    faqCategories: [],
					totaleFaq : '',
                    totaleStaticoFaq : null,
                    selectedName : '',
					isActive: true
				}
			},
			mounted(){
				fetch(`${BASE_URL}/wp-json/api/v1/info-faq`)
				.then(res => res.json())
				.then(data => {
					data.forEach(el => {                        
                        //FAQ
						this.faqs = data;
						this.totaleFaq++;
                        this.totaleStaticoFaq++;
					})
				})

                fetch(`${BASE_URL}/wp-json/wp/v2/faq_category`)
				.then(res => res.json())
				.then(data => {
					data.forEach(el => {      

                        let category = {
							name: el.name,
                            slug: el.slug,
							count : el.count
						}             
                        //FAQ
						this.faqCategories.push(category);
					})
				})
				
			},
			methods: {
				
				paginate (posts) {
					let page = this.page;
					let perPage = this.perPage;
					let from = (page * perPage) - perPage;
					let to = (page * perPage);
					return  posts.slice(from, to);
				},
				setPages() {
					let numberOfPages = Math.ceil(this.totaleFaq / this.perPage);
					this.pages = []; /* svuoto e ri-riempio */
					for (let index = 1; index <= numberOfPages; index++) {
						this.pages.push(index);
					}
				},
                selectCat(key) {
					this.selectedName = key;
				},
				resetFilters(){
					this.selectedName = '';
				}
			},
			computed: {				
				paginatedFaq(){
					this.totaleFaq = this.computedFaqs.length;
					return this.paginate(this.computedFaqs);
				},
				computedFaqs(){				
					
					return this.faqs.filter( //controllo tutti gli item e mi ritorna solo gli elementi per cui il return è sempre true
						(item) => {	
						    var name = this.selectedName ? (item.category.includes(this.selectedName)) : true;
							return name;
						}
					) /* filter */

				}
			},
			watch: { 
				totaleFaq() {
					this.setPages(); /* ogni volta che totaleFaq cambia esegi setPages */
				}
			},
		})
	}

}

export default filterPageFaq;